export default __webpack_public_path__ + "static/media/savings-e1454394256428.3d7c9b0f.jpg";